module.exports = __webpack_public_path__ + "static/media/v7.14f99060.mp4";